<template>
  <div>
    <div class="ele-table-tool ele-table-tool-default">
      <el-button @click="addTeacher" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">设置被审核教师</el-button>
    </div>
    <!-- 数据表格 -->
    <ele-data-table ref="table" :config="table" :data="teacherData" :current.sync="current" height="calc(100vh - 241px)" highlight-current-row>
      <el-table-column prop="auditedName" label="教师姓名" sortable="custom" show-overflow-tooltip />
      <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip />
      <el-table-column label="操作" width="280px" align="center" :resizable="false">
        <template #default="{ row }">
          <!--          <el-link @click="viewTeacher(row)" icon="el-icon-user" type="primary" :underline="false">查看教师</el-link>-->
          <el-popconfirm title="确定要删除此教师吗？" @onConfirm="removeTeacher(row)" class="ele-action">
            <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
          </el-popconfirm>
        </template>
      </el-table-column>
    </ele-data-table>
    <!-- 添加审核教师弹窗 -->
    <el-dialog
      title="设置被审核教师"
      :visible.sync="showTeacherEdit"
      width="650px"
      @closed="teacherForm = {}"
      :destroy-on-close="true"
      :lock-scroll="false"
    >
      <el-form :model="teacherForm" ref="teacherForm" :rules="teacherRoles" label-width="100px">
        <el-form-item label="教师:">
          <treeselect
            v-model="teacherForm.teacherIds"
            :options="teacherList"
            :required="true"
            :multiple="true"
            placeholder="请选择教师"
            :defaultExpandLevel="2"
            valueConsistsOf="LEAF_PRIORITY"
            :normalizer="
              (d) => {
                return { id: d.id, label: d.name };
              }
            "
            style="line-height: 20px"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showTeacherEdit = false">取消</el-button>
        <el-button type="primary" @click="saveTeacher">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect'; // 下拉树
  import '@riophae/vue-treeselect/dist/vue-treeselect.css';
  import { deleteGroupAuditedTeacher, getAllDepartTeachers, saveGroupAuditedTeacher, showGroupAuditedTeacher } from '@/config/api';

  export default {
    name: 'Approval',
    components: { Treeselect },
    props: {
      groupId: Number,
    },
    data() {
      return {
        table: {
          // 表格配置
          // url: '/teacherLeave/showGroupAuditedTeacher',
          page: false,
          // where: {groupId: this.groupId},
          // parseData(res) {
          //   if (res.resCode == 200) res.code = 0;
          //   return res;
          // }
        },
        current: null, // 表格选中数据
        showTeacherEdit: false,
        teacherForm: {},
        teacherRoles: {
          teacherIds: [{ required: true, message: '请选择审核级别', trigger: 'change' }],
        },
        teacherList: [], //老师数据
        teacherData: [], //老师数据
      };
    },
    watch: {
      /* 监听机构id变化 */
      groupId() {
        // this.table.where.groupId = this.groupId;
        this.getTeacherData();
      },
    },
    created() {
      this.getTeacherData();
    },
    methods: {
      // 添加审核组审核人
      addTeacher() {
        this.showTeacherEdit = true;
        this.teacherForm.groupId = this.groupId;
        if (this.teacherData.length > 0) {
          this.teacherForm.teacherIds = this.teacherData.map((d) => d.auditedId);
        }
        // this.teacherForm.teacherIds = row.tList.map(d => d.checkId)
        this.queryDept();
      },
      // 获取教师数据
      getTeacherData() {
        showGroupAuditedTeacher({
          groupId: this.groupId,
        }).then((res) => {
          if (res.data.resCode == 200) {
            this.teacherData = res.data.data;
          }
        });
      },
      //查询部门列表
      queryDept() {
        getAllDepartTeachers()
          .then((res) => {
            if (res.data.resCode == 200) {
              this.teacherList = this.$util.toTreeData(res.data.data, 'id', 'parentId');
              this.deleteChildren(this.teacherList);
            } else {
              this.$message.error(res.data.resMsg);
            }
          })
          .catch((e) => {
            this.$message.error(e.message);
          });
      },
      // 循环数组 children为空时删除 且部系年级下无children时禁用
      deleteChildren(data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].children) {
            if (data[i].children.length) {
              this.deleteChildren(data[i].children);
            } else {
              if (data[i].type !== 2) {
                delete data[i].children;
                data[i].isDisabled = true;
              }
            }
          }
        }
        return data;
      },
      // 添加审核教师
      saveTeacher() {
        let teacherIds = [...new Set(this.teacherForm.teacherIds)]; //js去重
        this.$refs['teacherForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.teacherForm) {
              if (this.teacherForm[key] !== null && this.teacherForm[key] !== undefined) {
                formData.append(key, this.teacherForm[key]);
              }
            }
            formData.set('teacherIds', teacherIds);
            saveGroupAuditedTeacher(formData).then((res) => {
              loading.close();
              if (res.data.resCode == '200') {
                this.showTeacherEdit = false;
                this.$message({ type: 'success', message: res.data.resMsg });
                this.getTeacherData();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            return false;
          }
        });
      },
      // 删除被审核教师
      removeTeacher(row) {
        const loading = this.$loading({ lock: true });
        let formData = new FormData();
        formData.append('groupId', row.groupId);
        formData.append('teacherId', row.auditedId);
        deleteGroupAuditedTeacher(formData).then((res) => {
          loading.close();
          if (res.data.resCode == '200') {
            this.$message({ type: 'success', message: '删除成功' });
            this.getTeacherData();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
    },
  };
</script>

<style scoped></style>
